module.exports = __webpack_public_path__ + "img/banner-05z.ef10cd50.png";